import React from 'react';
import ElipsisBox from '../../Shared/ElipsisBox';
import CustomMaterialTooltip from '../../Shared/StyledTooltip';
import styled from 'styled-components';
import { EmptyField } from '../../../healtheraComponents';

const DeclinedNote = ({ note }) => {
  return (
    <>
      {note ? (
        <CustomMaterialTooltip title={note}>
          <ElipsisBoxWrapper>
            <ElipsisBox maxLine={'2'} text={note} />
          </ElipsisBoxWrapper>
        </CustomMaterialTooltip>
      ) : (
        <EmptyField />
      )}
    </>
  );
};

const ElipsisBoxWrapper = styled.div`
  overflow-wrap: break-word;
`;

export default DeclinedNote;
